const { default: styled } = require('styled-components');
const { default: ImageList } = require('@mui/material/ImageList');

const internals = {};

module.exports = internals;

internals.ProfilePhotoFrame = styled.div`
    width: 100%;
    min-width: 0;
    border-radius: 22px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.08);

    img {
        display: block;
        width: 100%;
        aspect-ratio: 1;
        object-fit: cover;
    }

    @media screen and (max-width: 600px) {
        border-radius: 20px;
    }
`;

internals.ProfileConnectionsList = styled(ImageList)`
    margin: 0;
    overflow: visible;
`;

// Group the editable photo and controls without inheriting legacy div-depth editor styles.
internals.ProfilePhotoEditor = styled.figure`
    width: 100%;
    min-height: 0;
    display: flex;
    margin: 0 auto;
    background-size: cover;
    background-position: center;
    border-radius: inherit;
    position: relative;
    overflow: hidden;

    > img {
        display: block;
        width: 100%;
        aspect-ratio: 1;
        object-fit: cover;
    }
`;
